import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faTrash, faEdit, faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';

import {
    TICKETS_PATH,
    UPDATE_PASSWORD_REQUEST_PATH,
  } from '../config/routes';
import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Menus from '../components/Menus';
import Footer from '../components/Footer/Footer';

function Parameters() {

    return (
        <div>
            <NavigationBar />
            <h1>Aide</h1>
            <div className="p-3">
                <Link to={TICKETS_PATH} className="btn btn-primary" style={{ marginLeft: '10px' }}>
                    Mes demandes
                </Link>                    
                <Link to={UPDATE_PASSWORD_REQUEST_PATH} className="btn btn-primary" style={{ marginLeft: '10px' }}>
                    Mettre à jour mon mot de passe
                </Link>
                <h2>Se connecter / Se déconnecter</h2>
                <p>Pour se connecter il suffit de cliquer sur l'icone <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }}>
                        <FontAwesomeIcon icon={faSignInAlt} /> </Button> en haut à droite de la barre supérieure</p>
                <p>Pour se déconnecter il suffit de cliquer sur l'icone <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }}>
                        <FontAwesomeIcon icon={faSignOutAlt} /> </Button> en haut à droite de la barre supérieure</p>
                <p>Il est recommandé de changer votre mot de passe à la 1ère connexion</p>
                <p>Par sécurité vous seul connaissez votre mot de passe, dès sa saisie il est crypté dans la base de données</p>
                <p>Par sécurité vous devriez utiliser un mot de passe que vous n'utilisez nulle part ailleurs</p>
                <p>Par sécurité il est recommandé de se déconnecter dès que vous avez fini de mettre à jour votre site</p>
                
                <h2>Mettre à jour les paramètres généraux du site web</h2>
                <p>Une fois connecté vous pouvez mettre à jour les paramètes généraux: le site web, votre société et votre compte utilisateur</p>
                <p>Pour cela il vous suffit de cliquer sur le bouton "Paramètres" de la barre supérieure puis sur le bouton "Mettre à jour" du bloc concerné</p>
                <p>Après votre 1ère connexion il vous est recommandé de modifier votre mot de passe</p>
                
                <h2>Mettre à jour les paramètres généraux du site web</h2>
                <p>Une fois connecté vous pouvez mettre à jour les paramètes généraux: le site web, votre société et votre compte utilisateur</p>
                <p>Pour cela il vous suffit de cliquer sur le bouton "Paramètres" de la barre supérieure puis sur le bouton "Mettre à jour" du bloc concerné</p>
                <p>Après votre 1ère connexion il vous est recommandé de modifier votre mot de passe</p>
                
                <h2>Mettre à jour une page</h2>
                <p>Une fois connecté vous pouvez mettre à jour le contenu de chacune des pages du site web</p>
                <p>Pour cela il vous suffit de cliquer sur le bouton "Basculer en mode Admin" de la barre supérieure puis sur les divers boutons de mise à jour proposés"</p>
                <p>Pour vérifier le contenu après une mise à jour, vous pouvez cliquer sur le bouton "Basculer en mode standard"</p>
                <p>Quelques boutons proposés:</p>
                <p>                    
                    <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }}>
                        <FontAwesomeIcon icon={faEdit} />
                    </Button>: Mettre à jour
                </p>
                <p>
                    <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }}>
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>: Supprimer
                </p>
                <p>
                    <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }}>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </Button>: Remonter d'un rang
                </p>
                <p>
                    <Button variant="primary" className="btn-sm" style={{ margin: '0 5px' }}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </Button>: Descendre d'un rang
                </p>

                <h2>Demander une assistance / Signaler un problème</h2>
                <p>
                    Pour toute demande d'assistance ou pour signaler un problème n'hésitez pas à créer une nouvelle demande dans             
                    <Link to={TICKETS_PATH} className="btn btn-primary" style={{ marginLeft: '10px' }}>
                        Mes demandes
                    </Link>
                </p>
                <p>
                    Nous vous répondrons dans les plus brefs délais.
                </p>
            </div>
            <MediaList mediaKey='HELP_BOTTOM' maxItems={1}  isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default Parameters;